import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import { AnalyticsSlice, createAnalyticsSlice } from './slices/analyticsSlice'
import {
    PerformanceSlice,
    createPerformanceSlice
} from './slices/performanceSlice'
import {
    PermissionSlice,
    createPermissionSlice
} from './slices/permissionSlice'
import { StartDateSlice, createStartDateSlice } from './slices/startDateSlice'
import { UserSlice, createUserSlice } from './slices/userSlice'

type StoreState = UserSlice &
    AnalyticsSlice &
    PerformanceSlice &
    PermissionSlice &
    StartDateSlice

export const useStore = create<StoreState>()(
    persist(
        (...args) => ({
            ...createUserSlice(...args),
            ...createAnalyticsSlice(...args),
            ...createPerformanceSlice(...args),
            ...createPermissionSlice(...args),
            ...createStartDateSlice(...args)
        }),
        {
            name: 'app-store'
        }
    )
)
